/**
 * @deprecated This component is deprecated.
 * Use `@ordermentum/ui-shared/components/Base/Button` instead.
 *
 * Migration:
 * - Replace `<Button type="cancel">Cancel</Button>` with `<Button variant="secondary">Cancel</Button>`
 * - Replace `<Button type="submit">Save</Button>` with `<Button type="submit">Save</Button>`
 * - Replace `isInactive={true}` with `disabled={true}` or `loading={true}`
 *
 * See `components/Base/Button` for the new shadcn-style API with variant/size props.
 */
import Button from './Button';
import ButtonGroup from './ButtonGroup';

import TinyButton from './TinyButton';
import LinkButton from './LinkButton';
import TextButton from './TextButton';
import { ButtonProps } from './Button.types';

export default Button;
export { Button, LinkButton, TinyButton, TextButton, ButtonGroup, ButtonProps };
